// Links de ajuda do Fleapchat.
// Quando existe tutorial em vídeo para a funcionalidade, o "saiba mais" abre o
// vídeo na playlist oficial. Quando não existe, abre o WhatsApp da Fleap com a
// dúvida já contextualizada.

const TUTORIALS_PLAYLIST_ID = 'PLMcVgqUmWZdM';

export const FLEAP_WHATSAPP_NUMBER = '5543991518409';
export const TUTORIALS_PLAYLIST_URL = `https://www.youtube.com/playlist?list=${TUTORIALS_PLAYLIST_ID}`;

// featureName -> id do vídeo na playlist "Fleapchat: do básico ao avançado"
const VIDEO_TUTORIALS = {
  inboxes: 'EXo6spQlDcc',
  labels: 'mXM791HBriY',
  canned_responses: '_ys4BsJL0a8',
  team_management: 'U6ZqcY8gGmg',
  macros: 'fIFzIE_9Z5A',
  automation: 'C5WcmpH7sms',
  custom_attributes: 'SizXR7GPYVA',
};

// featureName -> assunto usado na mensagem pré-preenchida do WhatsApp
const WHATSAPP_TOPICS = {
  agent_bots: 'robôs de atendimento',
  agents: 'atendentes e funções',
  audit_logs: 'logs de auditoria',
  billing: 'planos e valores',
  campaigns: 'campanhas',
  captain: 'o assistente de IA',
  captain_billing: 'o assistente de IA',
  channel_email: 'o canal de e-mail',
  channel_facebook: 'o canal do Facebook',
  custom_roles: 'funções personalizadas',
  dashboard_apps: 'o painel de aplicativos',
  help_center: 'a central de ajuda',
  integrations: 'integrações',
  message_reply_to: 'respostas a mensagens',
  reports: 'relatórios',
  saml: 'login com SAML SSO',
  sla: 'SLA',
  webhook: 'webhooks',
  website_identity_validation: 'a validação de identidade do chat no site',
};

export function getFleapWhatsappUrl(topic) {
  const message = topic
    ? `Olá! Estou no Fleapchat e tenho uma dúvida sobre ${topic}.`
    : 'Olá! Estou no Fleapchat e tenho uma dúvida.';
  return `https://wa.me/${FLEAP_WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export function hasTutorialVideo(featureName) {
  return Boolean(VIDEO_TUTORIALS[featureName]);
}

export function getHelpUrlForFeature(featureName) {
  const videoId = VIDEO_TUTORIALS[featureName];
  if (videoId) {
    return `https://www.youtube.com/watch?v=${videoId}&list=${TUTORIALS_PLAYLIST_ID}`;
  }
  return getFleapWhatsappUrl(WHATSAPP_TOPICS[featureName]);
}
